module.exports = __webpack_public_path__ + "static/media/k-bottom.2f15b41f.svg";